<script>
import { Line } from 'vue-chartjs'
import { getStyle } from '@coreui/coreui/dist/js/coreui-utilities'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'

// @TODO combine with listing stats

export default {
  extends: Line,

  props: {
    labels: {
      type     : Array,
      required : true,
    },
    views: {
      type     : Array,
      required : true,
    },
    replies: {
      type     : Array,
      required : true,
    },
    averageViews: {
      type     : String,
      required : true,
    },
    averageReplies: {
      type     : String,
      required : true,
    }
  },

  methods: {
    render(){
      const brandSuccess = getStyle('--success') || '#4dbd74'
      const brandPrimary = getStyle('--primary') || '#20a8d8'
      const brandWarning = getStyle('--warning') || '#ffb818'
      const brandPurple = getStyle('--purple') || '#6f42c1'

      const { labels, views, replies, averageViews, averageReplies } = this

      this.renderChart({
        labels:  labels,
        datasets: [
          {
            label: 'Views',
            backgroundColor: 'transparent',
            borderColor: brandPrimary,
            pointBackgroundColor: brandPrimary,
            pointBorderColor: 'transparent',
            pointRadius: 4,
            borderWidth: 2,
            data: views,
          },
          {
            label: 'Replies',
            backgroundColor: 'transparent',
            pointBackgroundColor: brandSuccess,
            pointBorderColor: 'transparent',
            pointRadius: 4,
            borderColor: brandSuccess,
            borderWidth: 2,
            data: replies,
          },
          {
            label: 'Average Views',
            backgroundColor: 'transparent',
            pointBorderColor: 'transparent',
            borderColor: brandPurple,
            borderWidth: 1,
            borderDash: [8, 5],
            data: labels.map(() => averageViews),
          },
          {
            label: 'Average Replies',
            backgroundColor: 'transparent',
            pointBorderColor: 'transparent',
            borderColor: brandWarning,
            borderWidth: 1,
            borderDash: [8, 5],
            data: labels.map(() => averageReplies),
          }
        ]
      }, {
        tooltips: {
          enabled: false,
          custom: CustomTooltips,
          intersect: true,
          mode: 'index',
          position: 'nearest',
          callbacks: {
            labelColor: function (tooltipItem, chart) {
              return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor }
            }
          }
        },
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawOnChartArea: false
            }
          }],
          yAxes: [{
            ticks: {
              // beginAtZero: true,
              // maxTicksLimit: 5,
              // stepSize: Math.ceil(250 / 5),
              // max: 250
              min: 0,
            },
            gridLines: {
              display: true
            }
          }]
        },
        elements: {
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3
          }
        }
      })
    }
  }
}
</script>
